<template>
  <div class="product-select">
    <v-select
      ref="vueSelect"
      v-model="value"
      :clear-search-on-select="clearSearchOnSelect"
      :clearable="true"
      :filterable="false"
      :options="options"
      :placeholder="infoText"
      @input="$emit('input', $event)"
      @search="onSearch">
      <template slot="no-options">
        {{ nothingFoundText }}
      </template>
      <template
        slot="option"
        slot-scope="option">
        <div
          class="product-select__select-option"
          v-html="option.label"></div>
      </template>
      <template
        slot="selected-option"
        slot-scope="option">
        <div
          class="product-select__select-option"
          v-html="option.label"></div>
      </template>
      <template v-slot:spinner="spinner">
        <div
          v-show="spinner.loading"
          class="cp-round cp-spinner"></div>
      </template>
    </v-select>
  </div>
</template>

<script>
  import VueSelect from 'vue-select';
  import config from '../../../../config';
  import 'vue-select/dist/vue-select.css';
  import FetchHelper from '../../../helpers/OldFetchHelper';

  export default {
    components: {
      'v-select': VueSelect,
    },
    data() {
      return {
        options: [],
        value: ``,
      };
    },
    props: {
      clearSearchOnSelect: {
        default: true,
        type: Boolean,
      },
      infoText: {
        required: true,
        type: String,
      },
      nothingFoundText: {
        required: true,
        type: String,
      },
    },
    methods: {
      clear() {
        this.$refs.vueSelect.clearSelection();
      },
      onSearch(search, loading) {
        loading(true);
        this.search(loading, search, this);
      },
      search: _.debounce(async (loading, /** @type {string} */ searchString, vm) => {
        if(!searchString || searchString.length < 3) {
          loading(false);
          return;
        }
        const response = await FetchHelper.get({
          path: `${config.api.paths.products.basepath}${config.api.paths.products.paths.search}/${searchString}`,
        });
        if(response.success) {
          // eslint-disable-next-line no-param-reassign
          vm.options = response.data.map(r => { return { code: r.matchcode, label: `${r.matchcode} - ${r.title}` }; });
        }
        loading(false);
      }, 350),
    },
  };
</script>

<style lang="less" scoped>
  .product-select {
    background: #fff;
    display: inline-block;
    margin-right: 5px;
    width: 100%;

    &__select-option {
      margin: 0;
      padding: 0;
    }

    &__icon {
      background-image: url('/wp-content/themes/JointsWP/assets/icons/search.svg') !important;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 15px;
      height: 15px;
      padding-right: 27px;
      width: 15px;
    }
  }
</style>

<style lang="less">
  // non scoped style for vue-select overrides specific to this component
  @import '../../../assets/styles/rin-vue-select';

  .product-select {
    height: 46px;

    .vs__dropdown-menu {
      max-height: 500px;
    }

    .vs__dropdown-toggle,
    .vs__search,
    .vs__search:focus,
    .vs__selected {
      max-height: 38px;
    }

    .vs__search::placeholder {
      text-transform: uppercase;
    }

    .vs__selected-options {
      flex-wrap: nowrap;
      justify-content: flex-start;
      overflow: hidden;
      white-space: nowrap;
    }
  }
</style>
